"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.restrictionsApi = void 0;
const handlers_1 = require("../../api/handlers");
exports.restrictionsApi = (http, prefix = '/properties') => ({
    getById(propertyId, id) {
        return http.get(`${prefix}/${propertyId}x}/restriction/${id}`);
    },
    getAllForProperty(propertyId) {
        return http.get(`${prefix}/${propertyId}/restriction`).catch(handlers_1._404([]));
    },
    create(propertyId, restriction) {
        return http.post(`${prefix}/${propertyId}/restriction`, restriction);
    },
    update(propertyId, restriction) {
        return http.put(`${prefix}/${propertyId}/restriction/${restriction.id}`, restriction);
    },
    delete(propertyId, id) {
        return http.delete(`${prefix}/${propertyId}/restriction/${id}`);
    }
});
//# sourceMappingURL=restrictions.js.map